/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetLoyaltyCollectionsResponseDto { 
    id: string;
    parentOrganisationId: string;
    title: string;
    /** @deprecated */
    contentText?: string;
    validTill?: string;
    sortOrder: number;
    pushTitle?: string;
    pushText?: string;
    pushSendOnDate?: string;
    bannerBackgroundPhotoId?: string;
    bannerTitle?: string;
    status: number;
    productsCount: number;
    /**
     * Дата без Z на конце - передаётся - как есть в БД
     */
    readonly pushSendOn?: string;
}

